export function isEmbeddedCheckout(): boolean {
  return globalThis.self !== globalThis.top;
}
